module.exports = __webpack_public_path__ + "static/img/labourservices-11.1f69ff4.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/labourservices-11.png
// module id = CgTs
// module chunks = 1